import { GETTER_SERVER_VALIDATION_ERRORS } from './types';

export default {
  [GETTER_SERVER_VALIDATION_ERRORS]: ({ serverValidationErrors }) => serverValidationErrors,
};
